import PAApi from './_paApi.js';
import httpClient from '@/apis/base/httpclient';

class PaLayoutTemplateAPI extends PAApi {
  constructor() {
    super();
  }
  controllerName = 'PALayoutTemplates';

  /**
   * Lấy danh sách detail của mẫu bảng lương theo id
   * @param {*} payload
   * @returns
   */
  async getLayoutTemplateDetailByID(payload) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/getLayoutTemplateDetailByID',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Xóa danh sách detail của mẫu bảng lương theo id
   * @param {*} payload
   * @returns
   * TTLONG 10/02/2023
   */
  async deleteLayoutTemplateDetailByMasterID(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DeleteLayoutTemplateDetailByMasterID?masterId=' + payload,
    };

    return await httpClient.deleteAsync(request);
  }

  /**
   * Cập nhật Mẫu
   * @param {*} payload
   * @returns
   * TTLONG 10/02/2023
   */
  async updateLayoutTemplate(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/UpdateLayoutTemplate?isUpdate=' + payload.isUpdate,
      data: payload.saveParam,
    };

    return await httpClient.putAsync(request);
  }
  /**
   * check tồn tại mẫu bảng lương
   * @param {*} payload
   * @returns
   * TTLONG 10/02/2023
   */
  async checkExistsLayoutTemplate(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/CheckExistsLayoutTemplate?layoutTemplateName=' + payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Get mẫu bảng lương cho combobox
   * @param {*} payload
   * @returns
   * TTLONG 10/02/2023
   */
  async getDataComboboxForSalaryDetail(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetDataComboboxForSalaryDetail?type=' + payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Hàm lấy dữ liệu thêm mới
   * @param {} id
   * @returns
   */
  async getNewTemplate() {
    let request = {
      url: this.getAPIUrl() + '/new',
      data: {},
    };

    return await httpClient.getAsync(request);
  }
}

export default new PaLayoutTemplateAPI();
